import { render, staticRenderFns } from "./CardioParamsView.vue?vue&type=template&id=209fcba6"
import script from "./CardioParamsView.vue?vue&type=script&lang=js"
export * from "./CardioParamsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports